import React from "react";
import InviteAdminModal from "../InviteAdminModal";

const EditAdminModal = ({onClose, isOpen, admin, afterEdit}) => {
    return(
        <InviteAdminModal
            isEdit
            admin={admin}
            isOpen={isOpen}
            onClose={onClose}
            afterInvite={afterEdit}
        />
    )
}

export default EditAdminModal